/* NavItems.ts */

/* Ionic */
import {
  home,
  analytics,
  documents,
  apps,
  settings,
} from "ionicons/icons";

/* Font Awesome */
import {
  faChartColumn,
  faLineChart,
  faChartGantt,
} from "@fortawesome/free-solid-svg-icons";

/* Constants */
import { Paths } from "src/shared/constants/common/Paths";

/* Interfaces */
import { NavItemProps } from "src/shared/interfaces/common/NavItem";

/* Main Menu */
export const MAIN_MENU_NAV_ITEMS: NavItemProps[] = [
  {
    name: "Welcome",
    icon: home,
    path: `${Paths.HOME}`,
  },
  {
    name: "Insights",
    icon: analytics,
    path: `${Paths.INSIGHTS}${Paths.DESCRIPTIVE_STATISTICS}`,
  },
  /**
   * The standalone AI Assistant page is not listed, and App.tsx does
   * not route to it, because the agent's /chat endpoint is still a
   * stub that replies "The Insights Agent is not implemented yet".
   * The assistant is reachable where it does work: the toolbar icon on
   * the insights pages, which uses /spec.
   *
   * Restore both together — this entry, with
   * `requiredRole: UserRoles.INSIGHTS_AGENT`, and the ProtectedRoute.
   */
];

/* Insights Menu */
export const INSIGHTS_MENU_NAV_ITEMS: NavItemProps[] = [
  {
    name: "Descriptive Statistics",
    icon: faChartColumn,
    path: `${Paths.INSIGHTS}${Paths.DESCRIPTIVE_STATISTICS}`,
  },
  {
    name: "Survival Analysis",
    icon: faLineChart,
    path: `${Paths.INSIGHTS}${Paths.SURVIVAL_ANALYSIS}`,
  },
  {
    name: "Treatment Patterns",
    icon: faChartGantt,
    path: `${Paths.INSIGHTS}${Paths.TREATMENT_PATTERNS}`,
  },
];

/* Admin Dashboard */
export const ADMIN_DASHBOARD_NAV_ITEMS: NavItemProps[] = [
  {
    name: "Data handler",
    icon: documents,
    path: `${Paths.ADMIN_DASHBOARD}${Paths.DATA_HANDLER}`,
  },
  {
    name: "Feature selection",
    icon: apps,
    path: `${Paths.ADMIN_DASHBOARD}${Paths.FEATURE_SELECTION}`,
  },
  {
    name: "Settings",
    icon: settings,
    path: `${Paths.ADMIN_DASHBOARD}${Paths.SETTINGS}`,
  },
];
